import { AssessmentStatus, AssessmentStatusesEnum, UID } from 'types/types';

export type ListFilter = {
  searchTerm: string;
  statuses: AssessmentStatusesEnum[];
  organisationRole: 'performedBy' | 'producedFor' | null;
  organisationIds: UID[];
  propertyGroupIds: UID[];
  assessmentTypes: string[];
  assessedDateFrom: string | null;
  assessedDateTo: string | null;
  approvedDateFrom: string | null;
  approvedDateTo: string | null;
  orderBy: string;
  flagsSet: string[];
  flagsNotSet: string[];
};

export type ListFilterOptions = {
  organisationRequired: boolean;
  statuses: { id: AssessmentStatusesEnum; name: string; colour: string }[];
  organisations: { id: UID; name: string }[];
  assessmentTypes: { id: string; name: string }[];
  flags: { id: string; name: string }[];
  propertyGroups: { id: string; name: string; organisationName: string }[];
};

export type ListItem = {
  id: UID;
  reference: string;
  customReference: string | null;
  status: AssessmentStatusesEnum;
  type: {
    name: string;
  };
  assessed: {
    date: number;
    by: {
      id: UID;
      name: string;
      email: string;
    }[];
  };
  approved: null | {
    date: number;
    by: {
      id: UID;
      name: string;
      email: string;
    }[];
  };
  property: {
    id: UID;
    name: string;
    reference: string;
    customReference: string | null;
  };
  forOrganisation: {
    id: UID;
    name: string;
  };
  byOrganisation: {
    id: UID;
    name: string;
  };
};

export type ListData = {
  assessmentStatuses: Record<string, AssessmentStatus>;
};

export type AsesState = {
  listLoadStatus:
    | { status: 'initial' }
    | { status: 'loading'; type: 'filter' | 'pullToRefresh' }
    | { status: 'loaded' }
    | { status: 'error' };
  listLoadStatusEverLoaded: boolean;
  listFilter: ListFilter;
  listFilterDraft: ListFilter;
  listFilterLoadStatus: null | 'loading' | 'loaded';
  listFilterLoadStatusEverLoaded: boolean;
  listFilterOptions: ListFilterOptions;
  listFilterOptionsDraft: ListFilterOptions;
  list: Record<string, ListItem>;
  listPage: number;
  listData: ListData;
  listOffline: Record<string, ListItem>;
  listTotalCount: number;
};

export const AsesDefaultListFilter: AsesState['listFilter'] = {
  searchTerm: '',
  organisationRole: null,
  approvedDateFrom: null,
  approvedDateTo: null,
  assessedDateFrom: null,
  assessedDateTo: null,
  organisationIds: [],
  assessmentTypes: [],
  propertyGroupIds: [],
  flagsSet: [],
  flagsNotSet: [],
  statuses: [],
  orderBy: 'assessedDate:desc',
};
